import { lazy } from 'react'

export const Agreement = lazy(() => import('./agreement'))
